import React from "react";
import {
    NewsFeedDto,
    loadNewsFeedItems,
    getNewsFeed,
} from "../../ducks/newsfeed";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import { connect } from "react-redux";
import {
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Avatar,
} from "material-ui";
import {
    SetHeader,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
    SetBottomBarTab,
} from "../../ducks/common";
import AccountCircleIcon from "material-ui-icons/AccountCircle";
import { RouteProps, RouterProps } from "react-router";
import { NewsFeedTab } from "components/BottomBar/BottomBar";

interface INewsFeedPageProps {}

interface INewsFeedPageReduxProps {
    newsFeed: NewsFeedDto[];
    loading: boolean;
}

interface INewsFeedPageDispatchProps {
    loadNewsFeed: () => Promise<void>;
    setHeader: (value: string) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    setBottomBarTab: (tab?: number) => void;
}

interface INewsFeedPageState {}

type NewsFeedPageProps = INewsFeedPageProps &
    INewsFeedPageReduxProps &
    INewsFeedPageDispatchProps &
    RouteProps &
    RouterProps;

class NewsFeedPage extends React.Component<
    NewsFeedPageProps,
    INewsFeedPageState
> {
    constructor(props: NewsFeedPageProps) {
        super(props);
    }

    componentDidMount() {
        this.props.setHeader("Uutisvirta");
        this.props.loadNewsFeed();
        this.props.hideBackButton();
        this.props.setBottomBarTab(NewsFeedTab);
    }

    componentWillUnmount() {
        this.props.setHeader("");
        this.props.setBottomBarTab();
    }

    showNewsFeedItem = (id: number) => {
        this.props.history.push("/newsfeed/" + id);
    };

    renderNewsFeedItems = (newsFeed: NewsFeedDto[]): JSX.Element => {
        let items: JSX.Element[] = [];
        newsFeed.forEach((item: NewsFeedDto) => {
            if (item.title) {
                const date = new Date(item.date || "").toLocaleDateString("fi");
                const time = new Date(item.date || "").toLocaleTimeString("fi");

                // HTTPS is preferred over HTTP and access is denied to www2 -addresses
                const authorImageUrl =
                    item.authorImageUrl &&
                    !item.authorImageUrl.includes("//www2.")
                        ? item.authorImageUrl.replace(`http:`, `https:`)
                        : undefined;

                // Original images need to be resized to fit page properly
                const content =
                    item.content && item.content.rendered
                        ? item.content.rendered.replace(
                              `<img `,
                              `<img style="width: calc(100%); height: 100%" `
                          )
                        : "";

                items.push(
                    <ListItem
                        tabIndex={0}
                        className="hypo-newsfeed-item gridItem"
                        style={{ alignItems: "initial" }}
                        key={item.id}
                        onClick={() => {
                            this.showNewsFeedItem(item.id);
                        }}
                        onKeyDown={(event) => {
                            if (event.key === "Enter") {
                                this.showNewsFeedItem(item.id);
                            }
                        }}
                    >
                        {(authorImageUrl && (
                            <Avatar
                                className="hypo-avatar"
                                style={{ width: 48, height: 48 }}
                            >
                                <img
                                    src={authorImageUrl}
                                    alt={""}
                                    style={{ width: 48, height: 48 }}
                                />
                            </Avatar>
                        )) || (
                            <Avatar style={{ width: 48, height: 48 }}>
                                <AccountCircleIcon
                                    style={{
                                        width: 48,
                                        height: 48,
                                        backgroundColor: "#3a649e",
                                    }}
                                />
                            </Avatar>
                        )}

                        <ListItemText
                            classes={{ primary: "hypoblue" }}
                            primary={item.title.rendered}
                            secondary={`${date} ${time}`}
                        />
                    </ListItem>
                );
            }
        });

        return <List>{items}</List>;
    };

    render() {
        return (
            <div>
                {this.props.loading && (
                    <CircularProgress
                        style={{
                            width: 100,
                            height: 100,
                            color: "#92c9f0",
                            position: "absolute",
                            left: "calc(50% - 50px)",
                            top: "calc(50% - 50px)",
                        }}
                        thickness={2}
                    />
                )}
                {!this.props.loading && (
                    <div>{this.renderNewsFeedItems(this.props.newsFeed)}</div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): INewsFeedPageReduxProps => {
    const newsFeedState = getNewsFeed(state);
    return {
        newsFeed: newsFeedState.items,
        loading: newsFeedState.loading,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): INewsFeedPageDispatchProps => {
    return {
        loadNewsFeed: () => {
            return dispatch(loadNewsFeedItems());
        },
        setHeader: (value: string) => {
            dispatch(SetHeader(value));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        setBottomBarTab: (tab?: number) => {
            dispatch(SetBottomBarTab(tab));
        },
    };
};

export default connect<
    INewsFeedPageReduxProps,
    INewsFeedPageDispatchProps,
    INewsFeedPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(NewsFeedPage);



// WEBPACK FOOTER //
// ./src/views/newsfeed/NewsFeedPage.tsx